module.exports = "<flexbox class=mui-header :margin-left=0> <flexbox-item class=mui-header-left> <slot name=left> <div class=mui-header-back @click=handlerBackClick()> {{ backText }} </div> </slot> </flexbox-item> <flexbox-item class=mui-header-middle> <slot> <h1 class=mui-header-title> {{ title }} </h1> </slot> </flexbox-item> <flexbox-item class=mui-header-right> <slot name=right></slot> </flexbox-item> </flexbox>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/m-header/index.vue
 ** module id = 166
 ** module chunks = 0
 **/